import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  currentPlan: {
    defaultMessage: 'Current',
    description: 'Tag text for the current subscription plan',
    id: 'F53o5K',
  },
  recommendedPlan: {
    defaultMessage: 'Recommended',
    description: 'Tag text for the recommended subscription plan',
    id: 'YsLLa9',
  },
});
